<div class="card pt-5 pb-10 px-10" [ngClass]="{ 'displayed': currentMessage()?.display }" data-testid="player_message">
    <div class="close cursor-pointer flex" (click)="close()" data-testid="player_message-close">
        <img src="{{skinning.getImage('icon_close')}}">
    </div>
    <div class="title mt-4 mb-7 ps-2 fs-2 fw-semibold">
        @if(!currentMessage()?.title){
        <span>{{ 'common.popup.info' | transloco }}</span>
        } @else{
        <span>{{ currentMessage()?.title }}</span>
        }
    </div>
    <div class="text-left fs-7 font-light">{{ currentMessage()?.text }}</div>
    @if(currentMessage()?.url){
    <img class="qr-code self-center mt-10" [src]="currentMessage()?.qrCodeUrl | async">
    }
</div>